/************************************
MODULE:         Content functionality
WHAT IT DOES:   does all sorts of content minor javascript functionality which are too small to be moved to their own module
*************************************/

(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        define(['jquery'], factory);
    }
    else if (typeof exports === 'object') {
        module.exports = factory(require('jquery'));
    }
    else { root.returnExports = factory(root.jQuery); }
}(this, function ($) {
    var isInited = false;

    function init() {
        if(isInited)
            return;
        isInited = true;

        var footer = $('.js-page-footer'),
            header = $('.js-page-header'),
            content = $('.js-content'),
            homebanner = $(".js-home-banner");

        fixHeight(footer, header, content);
        $(window).on('resize:finished', fixHeight.bind(this, footer, header, content));

        if (homebanner.length) {
            fixHomeBanner(homebanner, header);
            $(window).on('resize:finished', fixHomeBanner.bind(this, homebanner, header));
        }

        buddyStoreItem();
        anchorLinkScrolling();
        fixNavLinks();
        initScrollToTop();
        initScrollToElement();
        initSelectUSA();
        initTransplantSingleLineOffer();

        if (!hasSupportForWebp()){
            var value = $(".home-banner__img").attr("data-bgset-nonoptimized")
            $(".home-banner__img").attr("data-bgset", value);

            if(value != undefined) {
                var imgUrl = value.split(',');
                $(".home-banner__img").css("background-image", "url(" + imgUrl[0] + ")");
            }

            $(".offer-message").addClass("nowebp");


            $(".webp_img").each(function( ) {
                var value = $(this).attr("data-src-nonoptimized")
                $(this).attr("data-src", value);
              });

              $(".webp_bg").each(function( ) {
                var value = $(this).attr("data-bg-nonoptimized")
                $(this).attr("data-bg", value);
            });

        }

        initDirectLinks();
        $(window).on('directlink:reinit', initDirectLinks);

        fixStoreListBtnHeight();
        $(window).on('resize:finished', fixStoreListBtnHeight);

        initSizeConvertLinks();
        $(window).on('sizeconvertlinks:reinit', initSizeConvertLinks)
    }

    function hasSupportForWebp(){
        const canvas = typeof document === 'object' ?
        document.createElement('canvas') : {};
        canvas.width = canvas.height = 1;
        return canvas.toDataURL ? canvas.toDataURL('image/webp').indexOf('image/webp') === 5 : false;
    }


    /*****/
    //make homepage banner to be some persent of windows height
    function fixHomeBanner(homebanner, header) {
      var ratio = homebanner.data('ratio');
      if (ratio) {
        var setBannerHeight = function () {
          homebanner.css(
            'height',
            window.App.globals.height * ratio - header.outerHeight()
          );
          setTimeout(() => {
            homebanner.addClass('home-banner--ratio-set');
          }, 2000);
        };

        if (header.outerHeight()) {
          setBannerHeight();
        } else {
          $(window).on('load', setBannerHeight);
        }
      }
    }
    /*****/

    /*****/
    //fix content area minimal height so that footer would always stick to the bottom of the window
    function fixHeight(footer, header, content) {
        content.css('min-height', window.App.globals.height - footer.outerHeight() - header.outerHeight() + window.App.globals.cookieHeight);
    }
    /*****/

    /*****/
    function buddyStoreItem() {
        var buddyStoreTrigger = $('.js-buddy-store-trigger');

        buddyStoreTrigger.on('click', function (e) {
            if (typeof e != 'undefined' && typeof e.preventDefault == "function")
                e.preventDefault();
            if (!$(e.target).is('.js-buddy-store-submit')) {
                var $this = $(this);
                $this.parent().find('.js-buddy-store-submit').trigger('click');
                $this.trigger('gatrack:send');
            }
        });
    }
    /*****/

    /*****/
    // links that scroll page to the element with certain id
    function anchorLinkScrolling(){
        var anchorLink = $('.js-scroll-id');
        if (!anchorLink.length)
            return;

        anchorLink.click(function (e) {
            e.preventDefault();
            var target = $(this).attr("href");            

            if(target.length) {
                if (navigator.userAgent.match(/iPad|iPhone|iPod|Android|Windows Phone/i)) {
                    document.querySelector(target).scrollIntoView({
                        behavior: 'smooth'
                    });
                } else {
                    $('html, body').animate({scrollTop: $(target).offset().top},{duration:500});
                }
            }
        });
    }
    /*****/

    /*****/
    //kentico doesn't allow you to add target="_blank", so this function detects external links and adds target="_blank"
    function fixNavLinks() {
        var rootUrl = window.appState.rootUrl || '/';
        var navLinks = $('.js-nav-fix-externals a');
        if (!navLinks.length)
            return;

        for (var i = 0, l = navLinks.length; i < l; i++) {
            var link = navLinks.eq(i),
                href = link.attr('href');
            if (!href)
                continue;

            // 'startsWith' Polyfill added for IE as startsWith doesn't work in IE and breaks the code.
            if (!String.prototype.startsWith) {
                Object.defineProperty(String.prototype, 'startsWith', {
                    value: function(search, rawPos) {
                        var pos = rawPos > 0 ? rawPos|0 : 0;
                        return this.substring(pos, pos + search.length) === search;
                    }
                });
            }

            if (href.startsWith('/')) {
                if (!href.startsWith(rootUrl)) {
                    href = rootUrl + href.replace(/^\//, '');
                    link.attr('href', href);
                }
            }
            
            var domain = href.replace('http://', '').replace('https://', '').split(/[/?#]/)[0];
            if (!(decodeURI(window.location.host) === domain || domain === "") && href[0] != '#')
                link.attr('target', '_blank');
        }

    }
    /*****/


    /*****/
    //links that scroll you back to the top of the page
    function initScrollToTop() {
        var scrollToTop = $('.js-scroll-to-top');
        var scrollToTopHome = $('.js-scroll-home-top');
        if (!scrollToTop.length && !scrollToTopHome)
            return;

        if(scrollToTop.length)
            scrollToTop.on('click', scrollToTopProcess);
        if (scrollToTopHome.length)
            scrollToTopHome.on('click', scrollToTopProcessHome);
    }

    function scrollToTopProcess(e) {
        if(typeof e != 'undefined' && typeof e.preventDefault == 'function')
            e.preventDefault();

        var top =  window.App.globals.getTop();

        if (top > 0) {
            window.App.globals.scrollElement.stop().animate({scrollTop: 0});
        }
    }

    function scrollToTopProcessHome(e) {
        if (typeof e != 'undefined' && typeof e.preventDefault == 'function')
            e.preventDefault();

        var top = window.App.globals.getTop(),
            link = $(e.target);

        if (!link.is('a'))
            link = link.parents('a');

        if (top > 0) {
            window.App.globals.scrollElement.stop().animate({scrollTop: 0}).promise().done(scrollTopComplete.bind(link));
        }
    }

    function scrollTopComplete() {
        $('.js-home-banner .js-search-store-input').focus();
    }
    /*****/

    function initScrollToElement() {
        var scrollToElement = $('.js-scroll-to-element');
        if (!scrollToElement.length)
            return;

        scrollToElement.on('click', scrollToElementProcess);
    }

    function scrollToElementProcess(e) {
        if (typeof e != 'undefined' && typeof e.preventDefault == 'function')
            e.preventDefault();

        var link = $(e.target);

        if (!link.is('a'))
            link = link.parents('a');

        var href = link.attr('href'),
            target = $(href);

        if (!target.length)
            return;

        $('html, body').stop().animate({ scrollTop: target.offset().top});
    }

    /*****/
    //some links on map on some devices (spotted android 5.1) might be now clickabble due to some sort of event propagation we can't influence, so we click them directly with js
    function initDirectLinks() {
        var links = $('.js-direct-link');
        links.off('click.direct');
        links.on('click.direct', clickDirectLink);
    }

    function clickDirectLink(e) {
        e.preventDefault();
        e.stopPropagation();
        var link = $(this);
        if (link.hasClass('js-tracked')) {
            $(document).trigger('gatrack:senddata', ['event', link.data('tracking-category'), link.data('tracking-action'), link.data('tracking-label')]);
        }
        window.location.href = link.attr('href');
    }
    /******/

    /***/
    function initSizeConvertLinks() {
        var links = $('.js-quote-spacesize-convert');
        links.off('click');
        links.on('click', clickConvertSpaceSize);
    }

    function clickConvertSpaceSize(e) {
        e.preventDefault();
        e.stopPropagation();

        var link = $(this);
        var spacesize = link.prev(".js-quote-spacesize");

        var sizeType = spacesize.data("size-type");
        var label = spacesize.data(sizeType + "-label");

        if (sizeType == "imperial"){
            sizeType = "metric";
        }
        else{
            sizeType = "imperial";
        }

        spacesize.find("span.js-room-size-label").html(spacesize.data(sizeType + "-size"));
        spacesize.find("span.js-room-size-type").html(spacesize.data(sizeType + "-label"));
        spacesize.data("size-type", sizeType)

        var trackingLabel = capitalizeFirstLetter(link.text().toLowerCase());
        link.find("span").html(capitalizeFirstLetter(label))

        if (link.hasClass('js-tracked')) {
            $(document).trigger('gatrack:senddata', ['event', link.data('tracking-category'), link.data('tracking-action'), link.data('tracking-label') + ' > ' + trackingLabel]);
        }
    }

    function capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }

    /***/


    /*****/
    //fix buttons height in store list
    var storeListTimeout = null;

    function fixStoreListBtnHeight() {
        if (storeListTimeout)
            clearTimeout(storeListTimeout);

        var lists = $('.js-store-item-list');
        if (!lists.length)
            return;

        lists.find('.store-item__button, .store-item').css('min-height', '');

        storeListTimeout = setTimeout(fixListsHeight.bind(this, lists), 500);
    }

    function fixListsHeight(lists) {
        for (var i = 0, l = lists.length; i < l; i++) {
            setStoreListBtnHeight(lists.eq(i));
        }
    }

    function setStoreListBtnHeight(list) {
        var buttons = window.App.globals.isMobileSmall ? list.find('.store-item') : list.find('.store-item__button'),
            maxHeight = 0;

        if (!buttons.length)
            return;

        for (var i = 0, l = buttons.length; i < l; i++) {
            maxHeight = Math.max(maxHeight, buttons.eq(i).outerHeight());
        }

        buttons.css('min-height', maxHeight);
    }
    /*****/

    /*****/
    //hiding states input if country is not USA in checkout your details form
    function initSelectUSA() {
        var country = $('.js-billing-address .js-select-country'),
            state = $('.js-select-usa-state');

        function setupStateSelect() {
            if (country.find("option:selected").text() === "USA") {
                state.show();
                state.find('select').attr('required', 'true');
            } else {
                state.hide();
                state.find('select').removeAttr('required');
            }
        }

        setupStateSelect();
        country.on('change', setupStateSelect);
    }
    /*****/

    /*****/
    //Moving SingleLineOffer web part content to page header and modifying it for Personal Storage page
    function initTransplantSingleLineOffer() {
        var $transplantTarget = $('div.js-sf-single-line-offer-transplant').eq(0);
        if ($transplantTarget.length > 0) {
            var $removeTarget = $transplantTarget.parentsUntil('div.container').last();
            $transplantTarget.css('margin-bottom', '25px');
            $('#sf-single-line-offer-transplant').append($transplantTarget).clone();
            $removeTarget.remove();
        }
    }
    /*****/

    return {
        init: init
    };

}));



/*****************
 ** WEBPACK FOOTER
 ** ./js/app/modules/app.content.js
 ** module id = 35
 ** module chunks = 24
 **/